import { hasSlotContent as e, returnFirstEl as t, warnIfUnmounted as n } from "../../common/utils/index.js";
import { t as r } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { BUTTON_IMPORTANCE_MODIFIERS as i, BUTTON_KIND_MODIFIERS as a, BUTTON_SIZE_MODIFIERS as o, ICON_POSITION_MODIFIERS as s } from "../button/button-constants.js";
import c from "../dropdown/dropdown.js";
import l from "./split-button-start.js";
import u from "./split-button-end.js";
import { Fragment as d, createBlock as f, createElementBlock as p, createSlots as m, createVNode as h, mergeProps as g, normalizeClass as _, normalizeStyle as v, openBlock as y, renderSlot as b, resolveComponent as x, withCtx as S } from "vue";
//#region components/split_button/split_button.vue
var C = {
	compatConfig: { MODE: 3 },
	name: "DtSplitButton",
	components: {
		SplitButtonEnd: u,
		DtDropdown: c,
		SplitButtonStart: l
	},
	inheritAttrs: !1,
	props: {
		startActive: {
			type: Boolean,
			default: !1
		},
		alphaActive: {
			type: Boolean,
			default: null
		},
		startAriaLabel: {
			type: String,
			default: null
		},
		alphaAriaLabel: {
			type: String,
			default: void 0
		},
		startIconPosition: {
			type: String,
			default: "left",
			validator: (e) => Object.keys(s).includes(e)
		},
		alphaIconPosition: {
			type: String,
			default: void 0,
			validator: (e) => e === void 0 || Object.keys(s).includes(e)
		},
		startLabelClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		startLeadingClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		alphaLeadingClass: {
			type: [
				String,
				Array,
				Object
			],
			default: void 0
		},
		startTrailingClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		alphaTrailingClass: {
			type: [
				String,
				Array,
				Object
			],
			default: void 0
		},
		alphaLabelClass: {
			type: [
				String,
				Array,
				Object
			],
			default: void 0
		},
		startDisabled: {
			type: Boolean,
			default: !1
		},
		alphaDisabled: {
			type: Boolean,
			default: null
		},
		startLoading: {
			type: Boolean,
			default: !1
		},
		alphaLoading: {
			type: Boolean,
			default: null
		},
		startTooltipText: {
			type: String,
			default: void 0
		},
		alphaTooltipText: {
			type: String,
			default: void 0
		},
		assertiveOnFocus: {
			type: Boolean,
			default: !1
		},
		disabled: {
			type: Boolean,
			default: !1
		},
		dropdownPlacement: {
			type: String,
			default: "bottom-end"
		},
		importance: {
			type: String,
			default: "primary",
			validator: (e) => Object.keys(i).includes(e)
		},
		kind: {
			type: String,
			default: "default",
			validator: (e) => Object.keys(a).includes(e)
		},
		endActive: {
			type: Boolean,
			default: !1
		},
		omegaActive: {
			type: Boolean,
			default: null
		},
		endAriaLabel: {
			type: String,
			default: null
		},
		omegaAriaLabel: {
			type: String,
			default: void 0
		},
		endDisabled: {
			type: Boolean,
			default: !1
		},
		omegaDisabled: {
			type: Boolean,
			default: null
		},
		endId: {
			type: String,
			default: void 0
		},
		omegaId: {
			type: String,
			default: void 0
		},
		endTooltipText: {
			type: String,
			default: void 0
		},
		omegaTooltipText: {
			type: String,
			default: void 0
		},
		size: {
			type: [String, Number],
			default: 300,
			validator: (e) => Object.keys(o).includes(String(e))
		},
		width: {
			type: String,
			default: null
		},
		showDivider: {
			type: Boolean,
			default: !0
		},
		startTo: {
			type: [String, Object],
			default: null
		},
		startReplace: {
			type: Boolean,
			default: !1
		},
		startHref: {
			type: String,
			default: null
		},
		startTarget: {
			type: String,
			default: null
		},
		startRel: {
			type: String,
			default: null
		}
	},
	emits: [
		"start-clicked",
		"alpha-clicked",
		"end-clicked",
		"omega-clicked"
	],
	data() {
		return { isDropdownOpen: !1 };
	},
	computed: {
		startButtonProps() {
			return {
				active: this.alphaActive ?? this.startActive,
				ariaLabel: this.alphaAriaLabel ?? this.startAriaLabel,
				assertiveOnFocus: this.assertiveOnFocus,
				disabled: this.disabled || (this.alphaDisabled ?? this.startDisabled),
				iconPosition: this.alphaIconPosition ?? this.startIconPosition,
				labelClass: this.alphaLabelClass ?? this.startLabelClass,
				leadingClass: this.alphaLeadingClass ?? this.startLeadingClass,
				trailingClass: this.alphaTrailingClass ?? this.startTrailingClass,
				loading: this.alphaLoading ?? this.startLoading,
				importance: this.importance,
				kind: this.kind,
				size: this.size,
				tooltipText: this.alphaTooltipText ?? this.startTooltipText,
				to: this.startTo,
				replace: this.startReplace,
				href: this.startHref,
				target: this.startTarget,
				rel: this.startRel,
				class: this.$attrs.class,
				style: this.$attrs.style
			};
		},
		endButtonProps() {
			return {
				id: this.omegaId ?? this.endId,
				active: this.omegaActive ?? this.endActive,
				ariaLabel: this.omegaAriaLabel ?? this.endAriaLabel,
				disabled: this.disabled || (this.omegaDisabled ?? this.endDisabled),
				importance: this.importance,
				kind: this.kind,
				size: this.size,
				tooltipText: this.omegaTooltipText ?? this.endTooltipText,
				class: this.$attrs.class,
				style: this.$attrs.style
			};
		}
	},
	created() {
		this.validateProps();
	},
	updated() {
		this.validateProps();
	},
	mounted() {
		n(t(this.$el), this.$options.name);
	},
	methods: {
		onStartClick() {
			this.$emit("start-clicked"), this.$emit("alpha-clicked");
		},
		onEndClick() {
			this.$emit("end-clicked"), this.$emit("omega-clicked");
		},
		validateProps() {
			this.validateStartButtonProps(), this.validateEndButtonProps(), this.validateShowDivider();
		},
		validateStartButtonProps() {
			e(this.$slots.default) || (e(this.$slots.startIcon) || e(this.$slots.alphaIcon)) && !(this.alphaTooltipText ?? this.startTooltipText) && console.warn("start-tooltip-text prop must be set if start button has an icon only");
		},
		validateEndButtonProps() {
			e(this.$slots.end) || e(this.$slots.omega) || (this.omegaTooltipText ?? this.endTooltipText) || console.warn("end-tooltip-text prop is required as it is an icon-only button");
		},
		validateShowDivider() {
			!this.showDivider && this.importance !== "clear" && console.warn("show-divider prop set to false has no effect when importance is not \"clear\". The divider is always shown for \"outlined\" and \"primary\" importances.");
		}
	}
};
function w(e, t, n, r, i, a) {
	let o = x("split-button-start"), s = x("split-button-end"), c = x("dt-dropdown");
	return y(), p("span", {
		"data-qa": "dt-split-button",
		class: _([
			"d-split-btn",
			{ "d-split-btn--no-divider": !n.showDivider && n.importance === "clear" },
			e.$attrs.class
		]),
		style: v([e.$attrs.style, { width: n.width }])
	}, [h(o, g(a.startButtonProps, {
		ref: "startButton",
		onClick: a.onStartClick
	}), m({
		default: S(() => [b(e.$slots, "default")]),
		_: 2
	}, [
		e.$slots.startEndIcon ? {
			name: "startIcon",
			fn: S(({ size: t }) => [e.$slots.startIcon ? b(e.$slots, "startIcon", {
				key: 0,
				size: t
			}) : b(e.$slots, "alphaIcon", {
				key: 1,
				size: t
			})]),
			key: "0"
		} : void 0,
		e.$slots.startEndIcon ? {
			name: "endIcon",
			fn: S(({ size: t }) => [b(e.$slots, "startEndIcon", { size: t })]),
			key: "1"
		} : void 0,
		e.$slots.startEndIcon ? void 0 : {
			name: "icon",
			fn: S(({ size: t }) => [e.$slots.startIcon ? b(e.$slots, "startIcon", {
				key: 0,
				size: t
			}) : b(e.$slots, "alphaIcon", {
				key: 1,
				size: t
			})]),
			key: "2"
		},
		e.$slots.leading ? {
			name: "leading",
			fn: S(() => [b(e.$slots, "leading")]),
			key: "3"
		} : void 0,
		e.$slots.trailing ? {
			name: "trailing",
			fn: S(() => [b(e.$slots, "trailing")]),
			key: "4"
		} : void 0
	]), 1040, ["onClick"]), e.$slots.end ? b(e.$slots, "end", { key: 0 }) : e.$slots.omega ? b(e.$slots, "omega", { key: 1 }) : (y(), p(d, { key: 2 }, [e.$slots.dropdownList ? (y(), f(c, {
		key: 0,
		placement: n.dropdownPlacement,
		onClick: t[0] || (t[0] = (e) => i.isDropdownOpen = !0),
		onOpened: t[1] || (t[1] = (e) => i.isDropdownOpen = e)
	}, {
		anchor: S((t) => [h(s, g({
			...t,
			...a.endButtonProps
		}, {
			active: i.isDropdownOpen,
			onClick: a.onEndClick
		}), {
			icon: S(({ size: t }) => [e.$slots.endIcon ? b(e.$slots, "endIcon", {
				key: 0,
				size: t
			}) : b(e.$slots, "omegaIcon", {
				key: 1,
				size: t
			})]),
			_: 3
		}, 16, ["active", "onClick"])]),
		list: S(({ close: t }) => [b(e.$slots, "dropdownList", { close: t })]),
		_: 3
	}, 8, ["placement"])) : (y(), f(s, g({ key: 1 }, a.endButtonProps, { onClick: a.onEndClick }), {
		icon: S(({ size: t }) => [e.$slots.endIcon ? b(e.$slots, "endIcon", {
			key: 0,
			size: t
		}) : b(e.$slots, "omegaIcon", {
			key: 1,
			size: t
		})]),
		_: 3
	}, 16, ["onClick"]))], 64))], 6);
}
var T = /* @__PURE__ */ r(C, [["render", w]]);
//#endregion
export { T as default };

//# sourceMappingURL=split-button.js.map